module.exports = __webpack_public_path__ + "media/king-dedede.30c3a694.wav";